<template>
  <div class="main userMain">
		<div class="header">
			<a class="backBtn" @click="$router.go(-1)">
                <i class="icon_back"></i> {{ $t('back') }}
            </a>
		</div>
		<div class="userInfoWrap">
			<div class="userInfoBox userBoxTop">
				<div class="user_title">{{ $t('profilePage.name') }}</div>
				<div class="user_con">{{ userInfo.name }}</div>
			</div>

			<div class="userInfoBox">
				<div class="user_title">{{ $t('profilePage.number') }}</div>
				<div class="user_con">{{ userInfo.uid }}</div>
			</div>

			<div class="userInfoBox">
				<div class="user_title">{{ $t('profilePage.viewLog') }}</div>
				<div class="userExList">
					<div class="exListBox" v-for="(history, index) in historyList" :key="history.name + index">
						<a :href="history.url">
							<div class="exPic"><img :src="history.imgUrl" alt="history image"></div>
							<div class="exName">{{ history.name }}</div>
						</a>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      historyList: [],
    }
  },
  mounted() {
	  this.getHistory()
  },
  computed: {
    ...mapGetters([
      'userInfo',
    ]),
  },
  methods: {
    getHistory() {
      const currentLang = localStorage.getItem('lang')
      this.$GuideAPI.getUserHistoricalData().then((res) => {
        this.historyList = res.data.map((val) => ({
          	name: currentLang && currentLang === 'en' ? val.showEngName : val.showLocalName,
          	imgUrl: val.visualIdentityImage,
          	url: val.showWebsiteUrl || val.showFacebookUrl,
        }))
      }).catch((err) => {
        console.error(err)
      })
    },
  },
}
</script>

<style>

</style>
